import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
//import 'rxjs/add/operator/do';
import { AuthenticationService } from './authentication.service';
import { Router, RouterStateSnapshot, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { state } from '@angular/animations';
//import { AuthGuard } from '../services/auth-guard.guard';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService, public router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.access_token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this.authenticationService.currentUserValue.access_token}`
                }
            });
        }

        return next.handle(request).pipe(
          tap(
            event => this.handleResponse(request, event),
            error => this.handleError(request, error)
          ));
    }

    handleResponse(req, event) {
      if (event instanceof HttpResponse) { }
    }

    handleError(req, err) {
      if (err instanceof HttpErrorResponse) {
        localStorage.setItem("siteSearchFilterVal", '');
        localStorage.setItem("cameraSearchFilterVal", '');
            if ((err.status === 401) || (err.status === 403)) {
              // this is where you can do anything like navigating
              this.router.navigate(['login']);
             // this.router.navigateByUrl('/login');
            }
          }
    }
}
